import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../config/config';


export function EiddayDashboard() {
  const [isEidday, setIsEidday] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkEiddayStatus = async () => {
      try {
        const response = await fetch(`${config.baseUrl}/api/auth/check-eidday`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        
        const data = await response.json();
        
        if (!data.isEidday) {
          navigate('/');
          return;
        }
        
        setIsEidday(true);
      } catch (error) {
        console.error('Error checking eidday status:', error);
        navigate('/');
      }
    };

    checkEiddayStatus();
  }, [navigate]);

  if (!isEidday) {
    return null;
  }


  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/');
  };


  return (
    <div className="container mx-auto px-4 py-8">
      <div className="container mx-auto px-4 py-8">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800">EidDay Dashboard</h1>
          <button
            onClick={handleLogout}
            className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded transition duration-200"
          >
            Logout
          </button>
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition duration-200">
            <h2 className="text-xl font-semibold mb-4">Insert Animal Status</h2>
            <p className="text-gray-600 mb-4">Update and manage animal status information</p>
            <a
              href="/eidday/insert-status"
              className="inline-block bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition duration-200"
            >
              Go to Insert Status
            </a>
          </div>



          <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition duration-200">
            <h2 className="text-xl font-semibold mb-4">Insert Animal Weight</h2>
            <p className="text-gray-600 mb-4">Record and update animal weight data</p>
            <a
              href="/eidday/insert-weight"
              className="inline-block bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition duration-200"
            >
              Go to Insert Weight
            </a>
          </div>
      </div>
    </div>
  );
}